module.exports = __webpack_public_path__ + "media/assets/images/payments/diners-34262740b54de424fe654e0048cb3187.png";